import {
  AdminUserWithRelations,
  Language,
  Operations,
} from "../../bookmydesk-api-sdk-typescript-axios";
import { kAdminUser } from "./admin-user";
import { kCompany } from "./company";

export const kAdminUsers: (AdminUserWithRelations & Operations)[] = [
  {
    ...kAdminUser,
    companies: [kCompany],
    _operations: {
      canDelete: true,
    },
  },
  {
    id: 3,
    email: "quinte@demo.workplaced.com",
    firstName: "Quinte",
    infix: "",
    lastName: "Leijssen",
    newsletter: true,
    roles: ["ROLE_CUSTOMER_ADMIN"],
    language: "NL" as Language,
    companies: [kCompany],
    _operations: {
      canDelete: true,
    },
  },
];
